// extracted by mini-css-extract-plugin
export var icon = "_89-1";
export var subtext = "_89-0";